import { render, staticRenderFns } from "./disabledReson.vue?vue&type=template&id=6b437115"
import script from "./disabledReson.vue?vue&type=script&lang=js"
export * from "./disabledReson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports